const SkeletonBPProfileStatistics = () => {
	const skeletonStyle = {
		background: '#f2f2f4',
		backgroundSize: '200% 100%',
		animation: 'skeleton-loading 1.2s ease-in-out infinite',
		borderRadius: 8
	};

	// Add keyframes for skeleton animation
	const skeletonKeyframes = `
	@keyframes skeleton-loading {
		0% { background-color: #f2f2f4; }
		50% { background-color: #f5f5f5; }
		100% { background-color: #f2f2f4; }
	}
	`;

	return (
		<div>
			<style>{skeletonKeyframes}</style>
			<>
				<div className="p-5">
					<div
						style={{
							...skeletonStyle,
							height: 32,
							margin: '0 auto 16px auto'
						}}
					/>
					{/* Chart skeleton */}
					<div
						style={{
							position: 'relative',
							height: 340,
							margin: '0 auto',
							// background: '#f8fafc',
							borderRadius: 8,
							overflow: 'hidden'
							// border: '1px solid #f2f2f4'
						}}>
						{/* Y axis skeleton */}
						<div
							style={{
								position: 'absolute',
								left: 4,
								top: 20,
								width: 2,
								height: 'calc(100% - 40px)',
								background:
									'linear-gradient(90deg, #f0f0f0 60%, #f2f2f4 100%)',
								borderRadius: 8
							}}
						/>
						{/* X axis skeleton */}
						<div
							style={{
								position: 'absolute',
								left: 32,
								bottom: 16,
								width: 'calc(100% - 48px)',
								height: 2,
								background:
									'linear-gradient(0deg, #f0f0f0 60%, #f2f2f4 100%)',
								borderRadius: 8
							}}
						/>
						{/* Bar skeletons */}
						{[0, 1, 2, 3, 4, 5, 6, 7].map((i) => (
							<div
								key={i}
								style={{
									position: 'absolute',
									left: 56 + i * 48,
									bottom: 32,
									width: 32,
									height: 60 + (i % 3) * 40,
									background: skeletonStyle.background,
									backgroundSize:
										skeletonStyle.backgroundSize,
									animation: skeletonStyle.animation,
									borderRadius: 6
								}}
							/>
						))}
					</div>
				</div>
			</>
		</div>
	);
};

export default SkeletonBPProfileStatistics;
